import { render, staticRenderFns } from "./mo-stu-dash.vue?vue&type=template&id=c877d2ce&"
import script from "./mo-stu-dash.vue?vue&type=script&lang=js&"
export * from "./mo-stu-dash.vue?vue&type=script&lang=js&"
import style0 from "./mo-stu-dash.vue?vue&type=style&index=0&id=c877d2ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports